import "@/App.css";
import { BrowserRouter, Routes, Route, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { ConfirmProvider } from "@/context/ConfirmContext";
import { setOnUnauthorized } from "@/lib/api";
import Layout from "@/components/Layout";
import Protected from "@/components/Protected";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Pending from "@/pages/Pending";
import { About, History, Departments, Contact } from "@/pages/Static";
import Dashboard from "@/pages/Dashboard";
import Polls from "@/pages/Polls";
import Portfolios from "@/pages/Portfolios";
import Discussions from "@/pages/Discussions";
import ClerkConsole from "@/pages/ClerkConsole";
import TransparencyLedger from "@/pages/TransparencyLedger";
import Sessions from "@/pages/Sessions";
import Archive from "@/pages/Archive";
import Surveys from "@/pages/Surveys";
import Command from "@/pages/Command";
import Reports from "@/pages/Reports";
import Setup from "@/pages/Setup";
import HRM from "@/pages/HRM";
import Careers from "@/pages/Careers";
import CareersMine from "@/pages/CareersMine";
import Funding from "@/pages/Funding";
import Me from "@/pages/Me";

function AuthWatcher() {
  const { setUser } = useAuth();
  const nav = useNavigate();
  useEffect(() => {
    setOnUnauthorized(() => {
      setUser(false);
      nav("/login");
    });
    return () => setOnUnauthorized(null);
  }, [nav, setUser]);
  return null;
}

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <ConfirmProvider>
            <AuthWatcher />
            <Toaster
              position="bottom-right"
              theme="dark"
              toastOptions={{
                style: {
                  background: "#12151A",
                  border: "1px solid rgba(255,255,255,0.14)",
                  borderRadius: 2,
                  color: "#E8EAED",
                  fontFamily: "'Inter Tight', system-ui, sans-serif",
                  fontSize: 13,
                },
              }}
            />
            <Layout>
              <Routes>
                <Route path="/" element={<Landing />} />
                <Route path="/setup" element={<Setup />} />
                <Route path="/about" element={<About />} />
                <Route path="/history" element={<History />} />
                <Route path="/departments" element={<Departments />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/careers" element={<Careers />} />
                <Route path="/careers/:id" element={<Careers />} />
                <Route path="/transparency" element={<TransparencyLedger />} />
                <Route path="/login" element={<Login />} />
                <Route path="/register" element={<Register />} />
                <Route path="/pending" element={<Pending />} />
                <Route path="/portal" element={<Protected><Dashboard /></Protected>} />
                <Route path="/portal/polls" element={<Protected><Polls /></Protected>} />
                <Route path="/portal/surveys" element={<Protected><Surveys /></Protected>} />
                <Route path="/portal/portfolios" element={<Protected><Portfolios /></Protected>} />
                <Route path="/portal/discussions" element={<Protected><Discussions /></Protected>} />
                <Route path="/portal/sessions" element={<Protected><Sessions /></Protected>} />
                <Route path="/portal/archive" element={<Protected><Archive /></Protected>} />
                <Route path="/portal/funding" element={<Protected><Funding /></Protected>} />
                <Route path="/portal/me" element={<Protected><Me /></Protected>} />
                <Route path="/portal/careers/mine" element={<Protected><CareersMine /></Protected>} />
                <Route path="/portal/reports" element={<Protected roles={["chief","deputy_chief","head_councillor","councillor","executive_director","band_registry_clerk"]}><Reports /></Protected>} />
                <Route path="/portal/hrm" element={<Protected roles={["chief","deputy_chief","head_councillor","councillor","executive_director"]}><HRM /></Protected>} />
                <Route path="/portal/command" element={<Protected roles={["chief","deputy_chief","head_councillor","councillor","executive_director"]}><Command /></Protected>} />
                <Route path="/portal/clerk" element={<Protected roles={["band_registry_clerk"]}><ClerkConsole /></Protected>} />
              </Routes>
            </Layout>
          </ConfirmProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}
